import {PaymentCodeEnum, PayoutWebModel} from "capitalist-shared/src/finance/payments";

export class CapitalistInternalPaymentModel extends PayoutWebModel {
  systemName = PaymentCodeEnum.Capitalist;

  values = {
    ...this.getValues(),
    destinationAccount: ''
  }

  options = {
    ...this.getOptions(),
    destaccounts: [],
    accounts: [],
    allaccounts: []
  }
}
